(function () {
  function parseRules(section) {
    const el = section.querySelector('[data-sr-rules]');
    if (!el) return null;
    const txt = (el.textContent || '').trim();
    if (!txt) return null;
    try { return JSON.parse(txt); } catch (e) { return null; }
  }

  function pickByRange(list, value) {
    if (!Array.isArray(list)) return null;
    const v = Number(value);
    if (!Number.isFinite(v)) return null;
    return list.find(r => v >= Number(r.min) && v <= Number(r.max)) || null;
  }

  function initSection(section) {
    // Evita doble init
    if (section.dataset.srInit === '1') return;
    section.dataset.srInit = '1';

    const rules = parseRules(section);

    const btn = section.querySelector('[data-sr-calc]');
    const note = section.querySelector('[data-sr-note]');
    const resultWrap = section.querySelector('[data-sr-result]');
    const resultSize = section.querySelector('[data-sr-size]');
    const heightInput = section.querySelector('input[id^="sr-height-"]');
    const inseamInput = section.querySelector('input[id^="sr-inseam-"]');

    if (!btn || !note || !resultWrap || !resultSize || !heightInput || !inseamInput) {
      // Si falta algo, permite reintentar en el futuro
      section.dataset.srInit = '0';
      return;
    }

    btn.addEventListener('click', function () {
      note.hidden = true;
      resultWrap.hidden = true;

      if (!rules) {
        note.textContent = 'No hay reglas configuradas para este modelo.';
        note.hidden = false;
        return;
      }

      const h = Number(heightInput.value);
      const i = Number(inseamInput.value);

      if (!h && !i) {
        note.textContent = 'Introduce tu estatura y/o longitud de paso.';
        note.hidden = false;
        return;
      }

      let picked = null;

      if (i) {
        picked = pickByRange(rules.byInseam, i);
        if (!picked && rules.fallbackMessage) {
          note.textContent = rules.fallbackMessage;
          note.hidden = false;
        }
      }

      if (!picked && h) {
        picked = pickByRange(rules.byHeight, h);
      }

      if (!picked) {
        note.textContent = 'No podemos recomendar una talla con los valores introducidos.';
        note.hidden = false;
        return;
      }

      resultSize.textContent = picked.size;
      resultWrap.hidden = false;
    });
  }

  function boot(root) {
    (root || document).querySelectorAll('.sr-wrap').forEach(initSection);
  }

  // Carga normal
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Shopify Theme Editor / secciones recargadas
  document.addEventListener('shopify:section:load', function (event) {
    // event.target es el contenedor de la sección recargada
    boot(event.target);
  });

  // (Opcional) también cuando seleccionas la sección en el editor
  document.addEventListener('shopify:section:select', function (event) {
    boot(event.target);
  });
})();
